import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToDuration',
  standalone: true,
})
export class SecondsToDurationPipe implements PipeTransform {

  transform(seconds: number): string {
    if (seconds == null || isNaN(seconds) || seconds <= 0) return $localize`0 seconds`;

    const units = [
      { name: $localize`year`, plural: $localize`years`, value: 31536000 },
      { name: $localize`month`, plural: $localize`months`, value: 2592000 },
      { name: $localize`week`, plural: $localize`weeks`, value: 604800 },
      { name: $localize`day`, plural: $localize`days`, value: 86400 },
      { name: $localize`hour`, plural: $localize`hours`, value: 3600 },
      { name: $localize`minute`, plural: $localize`minutes`, value: 60 },
      { name: $localize`second`, plural: $localize`seconds`, value: 1 }
    ];

    const parts: string[] = [];

    for (const unit of units) {
      const amount = Math.floor(seconds / unit.value);
      if (amount > 0) {
        parts.push(`${amount} ${amount > 1 ? unit.plural : unit.name}`);
        seconds -= amount * unit.value;
      }
    }

    return parts.join(' ');
  }
}
